
export default function Footer() {
  return (
    <footer className="bg-teal-600 text-white py-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/db348d46-2fd2-4e26-b6a0-ef8fa9110d33.png" 
                alt="ASELCO S.R.L. Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-bold">ASELCO S.R.L.</span>
            </div>
            <p className="text-sm text-white/90 leading-relaxed">
              Expert team developing modern iOS applications that enhance user experience and improve mobile device security.
            </p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <button 
                  onClick={() => document.getElementById('home')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Home
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  About
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Products
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('features')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-white/90 hover:text-white transition-colors cursor-pointer whitespace-nowrap"
                >
                  Features
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact Info</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-base mr-2 mt-1"></i>
                <span className="text-white/90">RIO DULCE 855, Carcarañá, S2138AOK, Argentina</span>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-base mr-2"></i>
                <span className="text-white/90">help@aselcosrl.com</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-base mr-2"></i>
                <span className="text-white/90">+1 4472272391</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
          <p className="text-white/80 mb-4 md:mb-0">
            © 2025 ASELCO S.R.L. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            className="text-white/80 hover:text-white transition-colors whitespace-nowrap"
            target="_blank"
            rel="noopener noreferrer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
